import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { extractDate } from "../../../Components/Functions/date.fun";
import { FcInTransit } from "react-icons/fc";

const ViewRFM = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  //   const duplicateRFQ = () => {
  //     navigate(`/rfq/new?duplicate=${id}`);
  //   };
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/rfm/getRFMById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcInTransit></FcInTransit>Request For Material
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View RFM</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">RFM Number</label>
                  <div className="w-100 col">
                    {(data?.rfmNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data?.purposeUse && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Purpose of Use
                  </label>
                  <div className="w-100 col">
                    {(data?.purposeUse || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data?.projectClientName && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Client Name</label>
                  <div className="w-100 col">
                    {(data?.projectClientName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data?.generatedBy && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Generated By</label>
                  <div className="w-100 col">
                    {(data?.generatedBy || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data?.createdAt && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Created At</label>
                  <div className="w-100 col">
                    {extractDate(data?.createdAt) || "N/A"}
                  </div>
                </div>
              )}

              {data?.notes && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Notes</label>
                  <div className="w-100 col">{data?.notes || "N/A"}</div>
                </div>
              )}

              <hr />
              <h2>Line Items</h2>
              <hr />
              {data &&
                data.lineItems?.map((lineItem, index) => {
                  return (
                    <div>
                      <h2>{++index}.</h2>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Particulars :
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.particulars || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item Unit :
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemUnit || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item Quantity :
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemQuantity || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <hr />
                    </div>
                  );
                })}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton
                  buttonText="Edit RFM"
                  href={`/req-for-material/${id}`}
                />

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewRFM;
